module.exports = __webpack_public_path__ + "static/media/SCB.7e375808.svg";